import React from "react";
import {useHistory} from "react-router-dom";
import {Authenticator, ForgotPassword, RequireNewPassword, SignIn} from 'aws-amplify-react';
import {checkState} from "../hooks/user";
import {PageHeader} from "../components/layout/PageHeader";


export function LoginPage() {
    const history = useHistory();

    const handleAuthStateChange = (state: any) => {
        if (state === 'signedIn') {
            checkState();
            history.push('/dashboard');
        }
    };

    return (
        <>
            <PageHeader/>
            <Authenticator hideDefault={true} onStateChange={handleAuthStateChange}>
                <SignIn/>
                <RequireNewPassword/>
                <ForgotPassword/>
            </Authenticator>
        </>
    )
}
